import type { FaireProductEntity } from "../../entity_types/product";

export const p_ujzepvwcay: FaireProductEntity = {
  token: "p_ujzepvwcay",
  type: "product",
  name: "Albers Short Sleeve Sweater Tee - Atlantic",
  brandToken: "b_9ut9ansxk1",
  brandName: "The Endery",
  imageUrl: "https://cdn.faire.com/fastly/1aa6c237bae528f0da9af2e3316fee659e8aebb42137c5be8388d3dec7e066ec.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6fc4d30f333b7d578dc27589a9c26a63601bbb91843ce6c34ad6faad1c8a6b50.jpeg",
    "https://cdn.faire.com/fastly/418d4d6a1c59be6842f7835137748a18da44674e03eea54e54913a5f933d5cf4.jpeg",
    "https://cdn.faire.com/fastly/d6640b86e3c13a871420db79d2dd761389c197c1d1cf6f106465236a1036121d.jpeg",
    "https://cdn.faire.com/fastly/372e0a67f400a9730a2c02c10efd1dbdb6ee51c7f04c4ffa255401a988ef4521.jpeg",
    "https://cdn.faire.com/fastly/7110727aa5df9317a0b75108e500257ade84dd545fcbf5f7129e386464460605.jpeg",
    "https://cdn.faire.com/fastly/49b76ca9ce408ff3e4e1d47ce4e8229b9e9760034b00b6ae06ca45fbbc5334b2.jpeg",
    "https://cdn.faire.com/fastly/f4d0c3ea06dac74ad567812a947d309d0fb4c86518aebfd1157047603b3b2c09.jpeg",
    "https://cdn.faire.com/fastly/a79a9f6282ab3f3f0a7e42bd9de3b1aece8fcd1e07b4546274bf8f4c912ec36b.jpeg"
  ],
  priceDollars: 75.6,
  description: "A relaxed fit with a more structured feel. The Albers Tee holds its shape with a firm, flat hand, creating clean, architectural lines that feel intentional from every angle. Inspired by the Bauhaus movement and the work of Josef Albers, color is arranged with quiet precision through blocks and grids that feel balanced and considered. Designed as a companion to the Bauhaus, it carries the same visual language in a form that layers easily and moves across wardrobes with flexibility.\n\n• 100% Pima cotton\n• Relaxed, boxy fit with drop shoulder\n• Minimal drape with a flat, slightly firm feel\n• Designed for easy layering\n• Holds its shape over time, maintaining a clean silhouette\n• Artisan made in Peru under Fair Trade practices",
  tags: [],
  msrpDollars: 168,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-13T05:50:25.768Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
